
import {FC} from "react";

import React from 'react';

import AcceptForm from "../../forms/claim-handling-forms/accept-form";

interface Interface{
    partSource: any;
    requestId: any;
    mode?: "View" | "Add new";
    onClose?: () => void;
}

const AcceptScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <AcceptForm
                    requestId={props.requestId}
                    partSource={props.partSource}
                    mode={props.mode}
                />
            
    );
}
export default AcceptScreen;
